module.exports = __webpack_public_path__ + "img/img-classify4_3.14b3b63e.png";